import PropTypes from 'prop-types';
import React from 'react';
import Style from './style.scss';
import ScItem from './scItem';
import { StyledParentDiv } from './styledSC';

class ScReference extends React.Component {
  handleClick() {
    const { children, ...rest } = this.props;
    this.props.handleClick(rest.targetItemReferenceId);
  }

  render() {
    return (
      <StyledParentDiv
        onClick={this.handleClick.bind(this)}
        className={Style.empty}
      >
        <ScItem
         {...this.props}
         intlObject={this.props.intlObject}
         reportAnalytics={this.props.reportAnalytics}
        />
      </StyledParentDiv>
    );
  }
}

ScReference.propTypes = {
  handleClick: PropTypes.func.isRequired,
  reportAnalytics: PropTypes.func.isRequired,
  intlObject: PropTypes.object.isRequired,
  children: PropTypes.array
};
export default ScReference;



// WEBPACK FOOTER //
// ./components/ServiceCatalog/scReference.js